import type { BaseIconProps } from "@/assets/icons/utils";
import { forwardRef } from "react";

export const IconDot = forwardRef<SVGSVGElement, BaseIconProps>(({ size, className, ...props }, ref) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    ref={ref}
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="8" cy="8" r="3" fill="currentColor" />
                </svg>
            );
        case "base":
            return (
                <svg
                    ref={ref}
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="10" cy="10" r="4" fill="currentColor" />
                </svg>
            );
        case "lg":
            return (
                <svg
                    ref={ref}
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="12"
                        cy="12"
                        r="3.5"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeOpacity="0.3"
                        strokeWidth="6"
                    />
                </svg>
            );
    }
});

IconDot.displayName = "IconDot";
